import { render, staticRenderFns } from "./board-group.vue?vue&type=template&id=0f6a5344&scoped=true&"
import script from "./board-group.vue?vue&type=script&lang=ts&"
export * from "./board-group.vue?vue&type=script&lang=ts&"
import style0 from "./board-group.vue?vue&type=style&index=0&id=0f6a5344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a5344",
  null
  
)

export default component.exports